<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p7"><span><a id="page_6"></a><a href="#/Contents#rp7">FRAGRANT BEEF STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>Dried mushrooms, red wine, and herbs give a rich flavor to this stock.</i></span></p>
<p class="make"><span>Makes about 3½ quarts</span></p>
<p class="hang"><span>4 quarts water</span></p>
<p class="hang"><span>1 cup dry red wine or water</span></p>
<p class="hang"><span>2 pounds each: short ribs of beef, fat trimmed, beef marrow bones</span></p>
<p class="hang"><span>1 pound cubed beef chuck, fat trimmed</span></p>
<p class="hang"><span>1 large onion, chopped</span></p>
<p class="hang"><span>3 each: thickly sliced medium carrots, ribs celery</span></p>
<p class="hang"><span>½ cup dried mushrooms</span></p>
<p class="hang"><span>1 clove garlic, halved</span></p>
<p class="hang"><span>10 black peppercorns</span></p>
<p class="hang"><span>1 bay leaf</span></p>
<p class="hang"><span>1 teaspoon each: dried basil and thyme leaves</span></p>
<p class="hang"><span>1 tablespoon soy sauce</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Heat all ingredients, except salt and pepper, to boiling in large Dutch oven; reduce heat and simmer, covered, 3 to 4 hours, skimming any foam from surface. Strain stock through double layer of cheesecloth, discarding bones, meat, vegetables, and seasonings; season to taste with salt and pepper. Refrigerate until chilled; remove congealed fat from surface of stock.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 16</span></p>
<p class="per1"><span>% calories from fat: 28</span></p>
<p class="per1"><span>Protein (g): 2.7</span></p>
<p class="per1"><span>Carbohydrate (g): 0.6</span></p>
<p class="per1"><span>Fat (g): 0.5</span></p>
<p class="per1"><span>Saturated fat (g): 0.3</span></p>
<p class="per1"><span>Cholesterol (mg): 3</span></p>
<p class="per1"><span>Sodium (mg): 42</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter017.vue?15009daa